import { render, staticRenderFns } from "./serviceDesign.vue?vue&type=template&id=71f11172&scoped=true"
import script from "./serviceDesign.vue?vue&type=script&lang=js"
export * from "./serviceDesign.vue?vue&type=script&lang=js"
import style0 from "./serviceDesign.vue?vue&type=style&index=0&id=71f11172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f11172",
  null
  
)

export default component.exports